module.exports = __webpack_public_path__ + "img/btn-replayedit-active.1b6dd5f3.svg";